import { Component } from 'react';
import type { ReactNode, ErrorInfo } from 'react';

interface Props {
  children: ReactNode;
  fallback?: (error: Error, reset: () => void) => ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  reset = () => {
    this.setState({ error: null });
  };

  render() {
    const { error } = this.state;
    if (error) {
      if (this.props.fallback) {
        return this.props.fallback(error, this.reset);
      }
      return (
        <div style={{
          padding: '2rem',
          margin: '1rem',
          background: 'var(--kumo-danger-light)',
          border: '1px solid var(--kumo-danger)',
          borderRadius: 'var(--kumo-radius-xl)',
          color: '#991b1b',
        }}>
          <h2 style={{ fontWeight: 'var(--kumo-font-weight-bold)', marginBottom: '0.5rem' }}>
            Something went wrong
          </h2>
          <p style={{ fontSize: 'var(--kumo-font-size-sm)', marginBottom: '1rem' }}>
            {error.message}
          </p>
          <button
            onClick={this.reset}
            style={{
              padding: '0.5rem 1rem',
              background: '#3E6AE1',
              color: 'white',
              border: 'none',
              borderRadius: 'var(--kumo-radius-md)',
              cursor: 'pointer',
              fontWeight: 'var(--kumo-font-weight-medium)',
            }}
          >
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
